const app = {
  sidebarMountEl: '#js-topPage-sidebar-app',
  cmsCategoriesFacets: '#cms-categories-facets-app',
  favoriteButtonMountEl: '.js-favorite-button-wrapper',
  favoriteButtonPopupMountEl: '#js-favorite-btn-popup'
}

const data = {
  productCategories: '#json-product-categories'
}

export { app, data }
